import { useEffect, useRef } from "react";
import TodoItem from './TodoItem';


const TodoList = ({todos, onToggleTodo, onDeleteTodo}) => {

    const listRef = useRef(null);

    // 當todo數量改變時，自動將列表滾動到最下方
    useEffect(() => {
      if (listRef.current) {
        listRef.current.scrollTop = listRef.current.scrollHeight;
      }
    }, [todos.length]);


  return (
   <ul className="todo-list" ref={listRef}>
      {todos.length === 0 ? (
        <li className="empty-message">No todos yet. Add your first task!</li>
      ) : (
        todos.map((todo) => (
          <TodoItem
            key={todo.id}
            todo={todo}
            onToggleTodo={onToggleTodo}
            onDeleteTodo={onDeleteTodo}
          />
        ))
      )}
    </ul>
  )
}

export default TodoList